export default "/_nuxt/0db65aaa7be6578f917f31623ddff0df.svg";